import { render, staticRenderFns } from "./BookingsSchedule.vue?vue&type=template&id=452374be&scoped=true&"
import script from "./BookingsSchedule.vue?vue&type=script&lang=js&"
export * from "./BookingsSchedule.vue?vue&type=script&lang=js&"
import style0 from "./BookingsSchedule.vue?vue&type=style&index=0&id=452374be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452374be",
  null
  
)

export default component.exports